import { render, staticRenderFns } from "./Nameing.vue?vue&type=template&id=6d23c078&scoped=true&"
import script from "./Nameing.vue?vue&type=script&lang=js&"
export * from "./Nameing.vue?vue&type=script&lang=js&"
import style0 from "./Nameing.vue?vue&type=style&index=0&id=6d23c078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23c078",
  null
  
)

export default component.exports